<template>
  <b-form @submit.prevent="onSubmit" id="form-tracking">
    <b-form-group label="Full Name:">
      <b-form-input
        class="mb-2"
        :state="state($v.tracking.name)"
        id="name"
        type="text"
        placeholder="Enter your full name"
        v-model="$v.tracking.name.$model"
        trim
      ></b-form-input>
      <b-form-invalid-feedback v-if="!tracking.name.required">Name field required</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Organization/Company:">
      <b-form-input
        class="mb-2"
        :state="state($v.tracking.organization)"
        id="organization"
        type="text"
        placeholder="Enter your organization/company"
        v-model="$v.tracking.organization.$model"
        trim
      ></b-form-input>
      <b-form-invalid-feedback v-if="!tracking.name.required">Organization/Company field required</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Contact No:">
      <b-form-input
        class="mb-2"
        :state="state($v.tracking.contact_no)"
        id="contact"
        type="text"
        placeholder="Enter your phone number"
        v-model="$v.tracking.contact_no.$model"
        trim
      ></b-form-input>
      <b-form-invalid-feedback v-if="!tracking.contact_no.required">Contact No field required</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Temperature:">
      <b-form-input
        class="mb-2"
        :state="state($v.tracking.temperature)"
        id="Temperature"
        type="text"
        placeholder="Enter your temperature"
        v-model="$v.tracking.temperature.$model"
        trim
      ></b-form-input>
      <b-form-invalid-feedback v-if="!tracking.temperature.required">Temperature field required</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Have you travelled overseas in the last 14 days?">
      <b-form-radio-group
        class="mb-1"
        :state="state($v.tracking.travel_china)"
        id="quarantine"
        @change="onChange($event)"
        v-model="$v.tracking.travel_china.$model"
        :options="options"
      >
        <b-form-invalid-feedback :state="state($v.tracking.travel_china)">Please select one</b-form-invalid-feedback>
      </b-form-radio-group>
      <b-form-select
        v-if="isChina"
        :state="state($v.tracking.country)"
        v-model="$v.tracking.country.$model"
        :options="formattedCountries"
      >
        <template v-slot:first>
          <b-form-select-option :value="null" disabled>-- Please select country --</b-form-select-option>
        </template>
      </b-form-select>
      <b-form-invalid-feedback v-if="!tracking.country.required">Please state country</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Do you have any of the following symptoms?">
      <b-form-checkbox-group
        class="mb-2"
        :state="state($v.tracking.symptoms)"
        id="symptoms"
        v-model="$v.tracking.symptoms.$model"
        :options="symptoms"
        stacked
      >
        <b-form-invalid-feedback :state="state($v.tracking.symptoms)">Please select one</b-form-invalid-feedback>
      </b-form-checkbox-group>
    </b-form-group>
    <b-button type="submit" variant="primary" block>Submit</b-button>
  </b-form>
</template>
<script>
import { required } from "vuelidate/lib/validators";
const fb = require("../firebase");
const countries = require("../countries.json");
export default {
  name: "HelloWorld",
  data() {
    return {
      isChina: false,
      options: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 }
      ],
      symptoms: [
        { text: "Fever", value: "fever" },
        { text: "Breathlessness", value: "breathlessness" },
        { text: "Cough", value: "cough" },
        { text: "Sore Throat", value: "sore throat" },
        { text: "None of the above", value: "none" }
      ],
      tracking: {
        name: "",
        organization: "",
        contact_no: "",
        temperature: "",
        travel_china: null,
        country: "",
        symptoms: [],
        date: this.$moment(new Date()).format("ddd, MMMM Do YYYY, h:mm:ss a")
      }
    };
  },
  validations() {
    if (this.isChina == true) {
      return {
        tracking: {
          name: { required },
          organization: { required },
          contact_no: { required },
          temperature: { required },
          travel_china: { required },
          country: { required },
          symptoms: { required }
        }
      };
    } else {
      return {
        tracking: {
          name: { required },
          organization: { required },
          contact_no: { required },
          temperature: { required },
          travel_china: { required },
          symptoms: { required }
        }
      };
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.tracking.$pending || this.$v.tracking.$error) return;

      //submit if no error
      fb.db
        .collection("visitors")
        .add(this.tracking)
        .then(() => {
          this.$alert({
            title: "Superskill Message",
            content: `Thank you ${this.tracking.name}`
          });
        });
    },
    state(validation) {
      return validation.$error || validation.$pending ? false : null;
    },
    onChange(event) {
      return event == 1 ? (this.isChina = true) : (this.isChina = false);
    }
  },
  computed: {
    formattedCountries() {
      return countries.map(item => {
        return {
          value: item.en_short_name,
          text: item.en_short_name
        };
      });
    }
  }
};
</script>
